import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-659145ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bottom-menu"
}
const _hoisted_2 = { class: "left" }
const _hoisted_3 = {
  key: 0,
  class: "bottom-menu mobile"
}
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { class: "timeline-link" }

import { computed, onMounted, ref, watch } from 'vue';

import ShareButton from '@/components/Content/ShareButton.vue';
import { RouteName } from '@/router';
import { useHomePageState } from '@/store/useHomePageState';
import { useInterfaceSettings } from '@/store/useInterfaceSettings';
import { logInteractionEvent } from '@/utils/analytics';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'BottomMenu',
  setup(__props) {

const { homePageState, isMelati } = useHomePageState();
const { showBottomMenu, setShowBottomMenu, setShowTotals } = useInterfaceSettings();
const mobile = ref(false);
const menuIsExpanded = ref(false);

const siteUrl = `${window.location.href}`;

watch(
  () => homePageState.value,
  () => {
    if (isMelati.value) {
      setShowBottomMenu(true);
      setShowTotals(true);
    }
  }
);

onMounted(() => {
  if (isMelati.value) {
    setShowBottomMenu(true);
    setShowTotals(true);
  }
});

const toggleExpander = () => {
  menuIsExpanded.value = !menuIsExpanded.value;
};

const closeExpander = () => {
  if (menuIsExpanded.value === true) menuIsExpanded.value = false;
};

const onMelatiButtonClick = () => {
  logInteractionEvent({
    page_type: 'home',
    event_name: 'add_melati_cta',
    interaction_type: 'click'
  });
};

const currentRoute = computed(() => {
  const routeName = useRoute().name?.toString().toLowerCase();
  return routeName === RouteName.Timeline || routeName === RouteName.Home ? routeName : '';
});

const onShareToggle = (show: boolean) => {
  if (show) {
    logInteractionEvent({
      page_type: 'home',
      event_name: 'open_share_toggle',
      interaction_type: 'click'
    });
  }
};

const onShare = (platform: string) => {
  logInteractionEvent({
    page_type: 'home',
    event_name: 'share',
    interaction_type: 'click',
    platform
  });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "quick-fade" }, {
      default: _withCtx(() => [
        (_unref(showBottomMenu))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(ShareButton, {
                  url: siteUrl,
                  onToggle: onShareToggle,
                  onShare: onShare
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "quick-fade" }, {
      default: _withCtx(() => [
        (_unref(showBottomMenu))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(ShareButton, {
                  url: siteUrl,
                  onToggle: onShareToggle,
                  onShare: onShare
                }),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_router_link, {
                    to: "/tijdlijn",
                    class: "nav"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Tijdlijn")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createVNode(_component_router_link, {
                onClick: onMelatiButtonClick,
                to: "/melati/new",
                class: "outline-btn"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, { name: "melati" }),
                  _createTextVNode(" Plaats je melati ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})